<main class="relative flex flex-col pb-6 pt-14 lg:pt-18">
  <!-- 배경 이미지 -->
  <div class="relative w-full">
    <img src="/event/top-bg-mo.svg" alt="top background" class="w-full flex lg:hidden" />
    <img src="/event/top-bg-pc.svg" alt="top background" class="w-full hidden lg:flex" />
    <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-4">
      <p class="sb-aggro text-white/40 font-light text-xs">홈 > 갤러리</p>
      <h1 class="text-white text-2xl lg:text-4xl">갤러리</h1>
      <p class="text-zinc-400 font-medium">다양한 모습을 전해드립니다.</p>
    </div>
  </div>

  <!-- 탭 -->
  <div class="bg-white sticky top-14 lg:top-18 z-10">
    <div class="promotion-tabs lg:px-0 lg:max-w-6xl lg:mx-auto">
      <button
        class="tab sb-aggro text-base font-light px-4!"
        [class.active]="activeTab() === 'news'"
        (click)="changeTab('news')">
        보도자료
      </button>
      <button
        class="tab sb-aggro text-base font-light px-4!"
        [class.active]="activeTab() === 'photo-gallery'"
        (click)="changeTab('photo-gallery')">
        갤러리
      </button>
      <button
        class="tab sb-aggro text-base font-light px-4!"
        [class.active]="activeTab() === 'video-gallery'"
        (click)="changeTab('video-gallery')">
        동영상
      </button>
    </div>
  </div>

  <!-- 라우터 아웃렛: 페이지 렌더링 -->
  <section>
    <router-outlet />
  </section>
</main>
